import {
  ProductsRepository,
  Either,
  ProductsFailure,
  Product,
  GeneralCategory,
  right,
  left,
  Color,
  Size,
  CategoryType,
  Sort,
  GetProdutcsResult,
} from "../../domain";
import { ProductsRemoteDataSourceError } from "../core";
import { ProductsRemoteDataSource } from "../data-sources";

export class ProductsRepositoryImpl implements ProductsRepository {
  constructor(private readonly remoteDataSource: ProductsRemoteDataSource) {}

  private handleError(error: Error): ProductsFailure {
    const message = error.message as ProductsRemoteDataSourceError;
    if (message === "NetworkError") return ProductsFailure.networkFailure();
    if (message === "CategoryNotFoundError")
      return ProductsFailure.categoryNotFoundFailure();
    if (message === "ProductNotFoundError")
      return ProductsFailure.productNotFoundFailure();
    return ProductsFailure.serverFailure();
  }

  public async getProductInfo(
    id: string
  ): Promise<Either<ProductsFailure, Product>> {
    try {
      const res = await this.remoteDataSource.getProductInfo(id);
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async getCategories(): Promise<
    Either<ProductsFailure, GeneralCategory[]>
  > {
    try {
      const res = await this.remoteDataSource.getCategories();
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async getColors(): Promise<Either<ProductsFailure, Color[]>> {
    try {
      const res = await this.remoteDataSource.getColors();
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async getSizes(): Promise<Either<ProductsFailure, Size[]>> {
    try {
      const res = await this.remoteDataSource.getSizes();
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async getProducts(
    categoryId: string,
    categoryType: CategoryType,
    page: number,
    sizes: Size[],
    colors: Color[],
    sort: Sort
  ): Promise<Either<ProductsFailure, GetProdutcsResult>> {
    try {
      const res = await this.remoteDataSource.getProducts(
        categoryId,
        categoryType,
        page,
        sizes,
        colors,
        sort
      );
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async getCartProducts(
    ids: string[]
  ): Promise<Either<ProductsFailure, Product[]>> {
    try {
      const res = await this.remoteDataSource.getCartProducts(ids);
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }
}
